import { render, staticRenderFns } from "./TheHistoryTitle.vue?vue&type=template&id=70afeb60"
var script = {}
import style0 from "./TheHistoryTitle.vue?vue&type=style&index=0&id=70afeb60&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports